import AbstractElectronPlatformUpdater
    from "~/operatorApplication/ts/platform/electron/AbstractElectronPlatformUpdater";

export default class LatestElectronPlatformUpdater extends AbstractElectronPlatformUpdater {
    protected get updateJsonFileName(): string {
        return "update2026.latest.json";
    }

    protected get updateZipDirectory(): string {
        return "latest";
    }

}